<template>
  <div class="clubcourses-box">
    <div class="search-box">
      <div class="search-box-fliter-box">
        <div class="search-box-fliter">
          <el-popover
            placement="bottom-start"
            width="200"
            trigger="click"
            v-model="coursePopoverShow"
            popper-class="pc-filter-popover"
          >
            <div
              class="filter-btn-box"
              :class="{ 'select-filter': courseStatusLabelList.length > 0 }"
              slot="reference"
            >
              Course Status<span class="arrow-box"
                ><i
                  class="el-icon-arrow-down"
                  :class="[{ 'submenu-icon-arrow': coursePopoverShow }]"
                ></i
              ></span>
            </div>
            <el-checkbox-group v-model="courseStatusLabelList">
              <el-checkbox
                v-for="(item, index) in courseStatusList"
                :label="item.name"
                :key="index"
              ></el-checkbox>
            </el-checkbox-group>
            <div class="popover-footer">
              <el-button
                type="text"
                size="small"
                class="clear-bt"
                @click="clearFilterLabel(1)"
                >Clear All</el-button
              >
              <el-button size="small" class="apply-bt" @click="applyFilter(1)"
                >Apply</el-button
              >
            </div>
          </el-popover>
        </div>
        <div class="search-box-reset-box">
          <el-button class="reset-bt" size="small" @click="resetFilter(1)"
            >Reset</el-button
          >
        </div>
      </div>

      <div class="search-box-li" v-if="showFilterLabels">
        <div
          class="filters-wrapper"
          v-for="(item, index) in courseStatusLabelList"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="myinfo-mid-content">
      <div class="list-head">
        <div class="flex_6">Course</div>
      </div>

      <div
        class="list-content"
        v-for="(item, index) in teacherCourseList"
        :key="index"
      >
        <div class="flex_4">
          <img class="info-img" :src="item.courseImg[0]" />
          <div class="info-detail">
            <el-tooltip
              effect="light"
              :content="item.courseName ? item.courseName : ''"
              placement="bottom-start"
            >
              <div class="detail-title">
                {{ item.courseName }}
              </div>
            </el-tooltip>
            <el-tooltip
              effect="light"
              :content="item.courseDesc ? item.courseDesc : ''"
              placement="bottom-start"
            >
              <div class="detail-content">
                {{ item.courseDesc }}
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="flex_1">
          <img src="@/assets/icon/drhat.png" class="realnameimg" />
          <el-tooltip
            effect="light"
            :content="item.covey_user.realname"
            placement="bottom-start"
          >
            <div class="realname">{{ item.covey_user.realname }}</div>
          </el-tooltip>
        </div>
        <div class="flex_1">
          <div class="price">Price:</div>
          <div class="price_text">
            &nbsp;C$ {{ (item.price / 100).toFixed(2) }}
          </div>
        </div>
        <div class="flex_1">
          <div class="price">Club Order:</div>
          <div class="price_text">&nbsp; {{ item.grouporder }}</div>
        </div>
        <div class="flex_1">
          <div class="price">Show in Club:</div>
          <div class="price_text">
            &nbsp; {{ item.isgroupshow | groupShow }}
          </div>
        </div>
        <div class="flex_1">
          <el-button
            size="small"
            class="checkbt"
            type="text"
            @click="openCheckSortDialog(item)"
            >Sort</el-button
          >
          <!-- <el-button
            size="small"
            class="checkbt"
            type="text"
            @click="openCheckCourseDialog(item)"
            >Check</el-button
          > -->
        </div>
      </div>
      <div v-if="teacherCourseList.length < 5">
        <div
          class="list-content"
          v-for="index in 5 - teacherCourseList.length"
          :key="index"
        >
          <div class="flex_3"></div>
          <div class="flex_1"></div>
          <div class="flex_1"></div>
          <div class="flex_1"></div>
          <div class="flex_1"></div>
        </div>
      </div>
      <KtPag
        style="text-align: right"
        :pageCount="pageParams.count"
        :currentPage="pageParams.page"
        :limit="pageParams.limit"
        @onChange="onPageSizeChange"
      ></KtPag>
    </div>
    <el-dialog
      title="Set Club Order"
      width="40%"
      :show-close="true"
      :visible.sync="checkSortDialog"
      :close-on-click-modal="false"
      @close="closeCheckSortDialog"
    >
      <el-form
        ref="courseSubmitForm"
        :model="courseSubmitForm"
        :rules="courseSubmitFormRules"
        label-width="150px"
        size="small"
      >
        <el-form-item label="Club Order:">
          <el-input-number
            :min="0"
            v-model="courseSubmitForm.grouporder"
            controls-position="right"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item label="Show in Club:">
          <el-switch
            v-model="courseSubmitForm.isgroupshow"
            active-color="#f48c06"
            inactive-color="#DCDFE6"
            active-text="Yes"
            inactive-text="No"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeCheckSortDialog">cancel</el-button>
        <el-button type="primary" size="small" @click="handleCheckSort"
          >Yes</el-button
        >
      </span>
    </el-dialog>
    <!-- <el-dialog
      title="审核课程"
      width="40%"
      :show-close="true"
      :visible.sync="checkCourseDialog"
      :close-on-click-modal="false"
      @close="closeCheckCourseDialog"
    >
      <el-form
        ref="courseForm"
        :model="courseForm"
        :rules="courseFormRules"
        label-width="120px"
        size="small"
      >
        <el-form-item label="开课学校：">
          {{
            courseForm.covey_school && courseForm.covey_school.name
              ? courseForm.covey_school.name
              : ""
          }}
        </el-form-item>
        <el-form-item label="开课导师：">
          {{
            courseForm.covey_user && courseForm.covey_user.realname
              ? courseForm.covey_user.realname
              : ""
          }}
        </el-form-item>
        <div v-for="(item, index) in courseForm.certifications" :key="index">
          <el-form-item :label="'资质' + (index + 1)">
            <div>
              <span class="senioritylabel">文字说明:</span
              >{{ item.qualification }}
            </div>
            <div class="seniorityimg_box">
              <span class="senioritylabel">图片材料:</span>
              <viewer
                :images="item.certification_img"
                v-if="item.certification_img.length > 0"
              >
                <img
                  class="seniorityimg"
                  v-for="(src, index2) in item.certification_img"
                  :src="src"
                  :key="index2"
                />
              </viewer>

            </div>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="openRefuseCheckCourseDialog"
          >拒 绝</el-button
        >
        <el-button type="primary" size="small" @click="handleCheckCourse"
          >Yes</el-button
        >
      </span>
    </el-dialog> -->
    <!-- <el-dialog
      title="审核课程"
      width="30%"
      :show-close="true"
      :visible.sync="refuseCheckCourseDialog"
      :close-on-click-modal="false"
      @close="closeRefuseCheckCourseDialog"
    >
      <el-form
        ref="courseForm"
        :model="courseForm"
        :rules="courseFormRules"
        label-width="120px"
        size="small"
      >
        <el-form-item label="Reason of rejection:">
          <el-input type="textarea" v-model="courseForm.reason"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeRefuseCheckCourseDialog"
          >取 消</el-button
        >
        <el-button type="primary" size="small" @click="handleRefuseCheckCourse"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import KtPag from "@/views/Comm/KtPag";
export default {
  components: {
    KtPag,
  },
  data() {
    return {
      teacherCourseList: [],
      pageParams: {
        page: 1,
        limit: 5,
        count: 0,
      },
      courseSubmitForm: {},
      checkSortDialog: false,
      checkCourseDialog: false, //审核弹窗
      refuseCheckCourseDialog: false, //审核拒绝弹窗
      courseForm: { reason: "" },
      courseFormRules: {
        reason: [
          { required: true, message: "拒绝原因不能为空!", trigger: "blur" },
        ],
      },
      courseSubmitFormRules: {
        grouporder: [
          { required: true, message: "拒绝原因不能为空!", trigger: "blur" },
        ],
      },
      courseStatusList: [
        { name: "Draft", status: -1 },
        { name: "Under review", status: 0 },
        { name: "Passed", status: 1 },
        { name: "Reject", status: 2 },
      ],
      courseStatusLabelList: [],
      coursePopoverShow: false,
    };
  },
  filters: {
    groupShow(val) {
      if (val) {
        return "Yes";
      } else {
        return "No";
      }
    },
  },
  computed: {
    showFilterLabels() {
      return this.courseStatusLabelList.length > 0;
    },
  },
  mounted() {
    this.getJoinedGroupCourse();
  },
  methods: {
    onPageSizeChange({ page, limit }) {
      this.pageParams.page = page;
      this.pageParams.limit = limit;
      this.getJoinedGroupCourse(2);
    },
    async getJoinedGroupCourse(type) {
      if (type === 1) {
        this.pageParams.page = 1;
      }
      let params = { ...this.pageParams };
      if (this.courseStatusLabelList.length > 0) {
        params["status"] = this.courseStatusList
          .map((item) => {
            for (let label of this.courseStatusLabelList) {
              if (label === item.name) {
                return item.status;
              }
            }
          })
          .filter((item) => item !== "" && item !== null && item !== undefined);
      }
      delete params.count;
      const { status, data, message } =
        await this.$api.courseApi.getJoinedGroupCourse(params);
      if (status === "0") {
        this.teacherCourseList = data.rows;
        this.pageParams.count = data.count;
        for (let item of this.teacherCourseList) {
          item["courseImg"] = JSON.parse(item.courseImg);
        }
      } else {
        this.$message({
          type: "error",
          message: message,
        });
      }
    },
    openCheckCourseDialog(row) {
      this.checkCourseDialog = true;
      this.courseForm = { ...row };
      this.courseForm.certifications = this.courseForm.certifications
        ? JSON.parse(this.courseForm.certifications)
        : [];
      if (Array.isArray(this.courseForm.certifications)) {
        for (let item of this.courseForm.certifications) {
          let arr = [];
          arr.push(item.certification_img);
          item["certification_img"] = item.certification_img ? arr : [];
        }
      }
    },
    async handleCheckSort() {
      if (
        !this.courseSubmitForm.grouporder &&
        this.courseSubmitForm.grouporder !== 0
      ) {
        this.$message({
          type: "warning",
          message: "Please set the order of the club courses",
        });
        return;
      }
      let params = {
        id: this.courseSubmitForm.id,
        grouporder: this.courseSubmitForm.grouporder,
        isgroupshow: this.courseSubmitForm.isgroupshow ? 1 : 0,
      };
      const { status, message } = await this.$api.courseApi.checkGroupCourse(
        params
      );
      this.$message({
        message: message,
        type: status === "0" ? "success" : "error",
      });
      if (status === "0") {
        this.checkSortDialog = false;
        this.getJoinedGroupCourse();
      }
    },
    openCheckSortDialog(row) {
      this.checkSortDialog = true;
      this.courseSubmitForm = {
        grouporder: row.grouporder,
        isgroupshow: row.isgroupshow,
        id: row.id,
      };
    },
    closeCheckSortDialog() {
      this.checkSortDialog = false;
      this.courseSubmitForm = {
        grouporder: "",
        id: "",
      };
    },
    closeCheckCourseDialog() {
      // console.log("this.schoolForm----", this.schoolForm);
      this.$refs["courseForm"].resetFields();
      this.checkCourseDialog = false;
      this.courseForm = {
        name: "",
      };
    },
    async handleCheckCourse() {
      this.$confirm("Are you sure you agree?", "Prompt", {
        type: "warning",
      })
        .then(async () => {
          let params = {
            id: this.courseForm.id,
            groupId: this.courseForm.groupId,
            status: 1,
          };
          const { status, message } =
            await this.$api.courseApi.checkGroupCourse(params);
          this.$message({
            message: message,
            type: status === "0" ? "success" : "error",
          });
          if (status === "0") {
            this.checkCourseDialog = false;
            this.getCoveyCourseList(2);
          }
        })
        .catch(() => {});
    },
    openRefuseCheckCourseDialog() {
      this.refuseCheckCourseDialog = true;
    },
    closeRefuseCheckCourseDialog() {
      this.refuseCheckCourseDialog = false;
    },
    async handleRefuseCheckCourse() {
      if (!this.courseForm.reason) {
        this.$message({
          type: "warning",
          message: "Reason for review rejection cannot be empty!",
        });
        return;
      }
      this.$confirm("Are you sure you agree?", "Prompt", {
        type: "warning",
      })
        .then(async () => {
          let params = {
            id: this.courseForm.id,
            groupId: this.courseForm.groupId,
            reason: this.courseForm.reason,
            status: 2,
          };
          const { status, message } =
            await this.$api.courseApi.checkGroupCourse(params);
          this.$message({
            message: message,
            type: status === "0" ? "success" : "error",
          });
          if (status === "0") {
            this.refuseCheckCourseDialog = false;
            this.checkCourseDialog = false;
            this.getCoveyCourseList(2);
          }
        })
        .catch(() => {});
    },
    clearFilterLabel(type) {
      if (type === 1) {
        this.courseStatusLabelList = [];
      }
    },
    applyFilter(type) {
      if (type === 1) {
        this.getJoinedGroupCourse(1);
        this.coursePopoverShow = false;
      }
    },
    resetFilter(type) {
      if (type === 1) {
        this.courseStatusLabelList = [];
        this.getJoinedGroupCourse(1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.clubcourses-box {
  // padding: 24px;
  // box-sizing: border-box;
  // border-radius: 8px;
  // background-color: #fff;
  // box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  .search-box {
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #ffffff;
    padding: 12px 24px;
    margin-bottom: 24px;
    box-sizing: border-box;
    .search-box-fliter-box {
      display: flex;
      justify-content: space-between;
      .search-box-fliter {
        display: flex;
      }
      .search-box-reset-box {
        .reset-bt {
          font-size: 14px;
        }
      }
    }
    .select-filter {
      color: #f48c06 !important;
      border-color: #f8d19e !important;
      background-color: #ffffff !important;
    }
    .filter-btn-box {
      font-weight: 600;
      color: #7e8088;
      min-width: 50px;
      padding: 6px 12px;
      border-radius: 4px;
      border: 1px solid #dadbdd;
      margin-right: 12px;
      box-sizing: border-box;
      cursor: pointer;
      &:hover {
        color: #f48c06;
        border-color: #f8d19e;
        background-color: #ffffff;
      }
      .arrow-box {
        margin-left: 6px;
        i {
          transition: all 500ms;
          font-size: 12px;
          &:hover {
            color: #f48c06;
            border-color: #f8d19e;
            background-color: #ffffff;
          }
        }
      }
      .submenu-icon-arrow {
        transform: rotate(180deg);
      }
    }
    .reset-bt {
      font-size: 14px;
      color: #7e8088;
      &:hover {
        color: #f48c06;
        border-color: #f8d19e;
        background-color: #ffffff;
      }
    }
  }
  .search-box-li {
    // height: 35px;
    // padding: 6px 0;
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    .filters-wrapper {
      color: #7e8088;
      font-size: 14px;
      // line-height: 22px;
      font-weight: 600;
      background-color: #efeff0;
      margin: 0 10px 10px 0;
      padding: 3px 12px;
      // border: none;
      border-radius: 50px;
      box-sizing: border-box;
    }
  }
  .senioritylabel {
    margin-right: 20px;
  }
  .seniorityimg {
    width: 200px;
    height: 200px;
  }
  /deep/.el-switch__label.is-active {
    color: #f48c06;
  }
  .el-button--primary {
    background: #f48c06;
    border-color: #f48c06;
  }
  .myinfo-mid-content {
    padding: 24px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    .flex_1 {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      .realnameimg {
        width: 12px;
        height: 12px;
        margin-right: 5px;
      }
      .realname {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181d2c;
      }
      .price {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181d2c;
      }
      .price_text {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #f48c06;
      }
      .checkbt {
        color: #f48c06;
        // border: none;
        // outline: none;
        // background: #f48c06;
        &:hover {
          opacity: 0.54;
        }
      }
    }
    .flex_4 {
      flex: 4;
    }
    .list-head {
      height: vh(70);
      line-height: vh(70);
      font-size: 18px;
      font-weight: 500;
      color: #181d2c;
      box-sizing: border-box;
    }
    .list-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      height: vh(120);
      padding: vh(24) 0;
      box-sizing: border-box;
      border-top: 1px solid #dbd9d6;
      font-size: 14px;
      .info-img {
        width: 20%;
        height: 100%;
        border-radius: 8px;
        display: inline-block;
      }
      .info-detail {
        width: 80%;
        display: inline-block;
        padding-left: vw(16);
        box-sizing: border-box;
        .detail-title {
          height: vh(24);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #181d2c;
          line-height: vh(24);
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .detail-content {
          height: vh(48);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #181d2c;
          line-height: vh(24);
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>
